import { render, staticRenderFns } from "./allListStage1Region.vue?vue&type=template&id=bbb1bf88&scoped=true"
import script from "./allListStage1Region.vue?vue&type=script&lang=js"
export * from "./allListStage1Region.vue?vue&type=script&lang=js"
import style0 from "./allListStage1Region.vue?vue&type=style&index=0&id=bbb1bf88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb1bf88",
  null
  
)

export default component.exports